import { sphere } from '../../learn/assets/images/sphere';

import { logo } from '../assets/images/logo';
import { PreloadableAsset, PreloadableAssetType } from '../types/asset/preloading.types.ts';

export const CRITICAL_ASSETS: PreloadableAsset[] = [
  {
    type: PreloadableAssetType.Image,
    url: sphere,
  },
  {
    type: PreloadableAssetType.Image,
    url: logo,
  },
];
